module.exports = __webpack_public_path__ + "static/media/BlackPlusShirt.3a9dd37a.png";